<div class="pv-input">
	@if (label) {
		<label>{{ label }}</label>
	}
	<div>
		@if (icon) {
			<i aria-hidden="true" [class]="icon"></i>
		}
		<p>
			@if (valueTemplate) {
				<ng-template [ngTemplateOutlet]="valueTemplate" [ngTemplateOutletContext]="generateContext(value)" />
			} @else {
				{{ value }}
			}
		</p>
	</div>
</div>
